<script lang="ts">
    import {Component, Vue, Watch} from 'vue-facing-decorator'
    import {CHANGE_PRICE_EVENT, EventBus, SHOW_NOTIFICATIONS} from '@/utils/event-bus'

    @Component
    export class BookingMixin extends Vue {
        answersToQuestions = null
        nmiPaymentSuccessUrl = null

        onAnswersChanged(answersUpdated) {
            if (this.answersToQuestions === null) {
                this.answersToQuestions = [...answersUpdated]
            } else {
                answersUpdated.forEach(answerUpdated => {
                    const answerExistsIndex = this.answersToQuestions.findIndex(a =>
                        answerUpdated.processId
                            ? a.processId === answerUpdated.processId && a.questionId === answerUpdated.questionId
                            : a.questionId === answerUpdated.questionId
                    )

                    if (answerExistsIndex === -1) {
                        this.answersToQuestions.push(answerUpdated)
                    } else {
                        this.answersToQuestions[answerExistsIndex] = answerUpdated
                    }
                })
            }
        }

        //TODO Remove this and VendorMessagesModal and replace them to more advanced PrepareBookMessagesModal with PrepareBookAdapter
        prepareBookResponseProcessing(prepareBookResponse, offerKey, prepareBookRequest, changePrice) {
            if (parseInt(prepareBookResponse.status, 10) > 2 && +prepareBookResponse.status !== 15) {
                //TODO Setup messages UI
                if (prepareBookResponse.errors) {
                    prepareBookResponse.errors.forEach(e => {
                        if (e.message) {
                            if (e.errorType === 'external') {
                                if (e.token === 'external_150' || e.token === 'external_23') {
                                    EventBus.$emit(
                                        'SHOW_OFFER_NOT_AVAILABLE_CITIZENSHIP',
                                        prepareBookRequest.tourists[0].citizenshipId
                                    )
                                } else {
                                    this.$toast.error(this.$t('error_message.something_went_wrong'), {queueable: true})
                                }
                            } else {
                                this.$toast.error(e.message, {queueable: true})
                            }
                        } else {
                            this.$toast.error(this.$t('error_message.prepare_book_unknown_error'), {
                                queueable: true,
                            })
                        }
                    })
                } else if (prepareBookResponse.warnings) {
                    prepareBookResponse.warnings.forEach(warning =>
                        this.$toast.warning(warning.message, {queueable: true})
                    )
                } else {
                    this.$toast.error(this.$t('error_message.prepare_book_unknown_error'), {
                        queueable: true,
                    })
                }
                return false
            } else {
                if (prepareBookResponse.warnings?.length) {
                    prepareBookResponse.warnings.forEach(warning => {
                        if (warning.token === 'external_price_has_been_changed') {
                            if (offerKey) {
                                if (changePrice) {
                                    changePrice(offerKey, prepareBookResponse)
                                } else {
                                    EventBus.$emit(CHANGE_PRICE_EVENT, {offerKey, prepareBookResponse})
                                }
                            }
                            this.$toast.warning(this.$t(`warning_message.${warning.token}`))
                        }
                    })
                }
                if (prepareBookRequest?.adjustedPriceAmount) {
                    if (offerKey) {
                        if (changePrice) {
                            changePrice(offerKey, prepareBookResponse)
                        } else {
                            EventBus.$emit(CHANGE_PRICE_EVENT, {offerKey, prepareBookResponse})
                        }
                    }
                }
                if (prepareBookResponse.vendorMessages && prepareBookResponse.vendorMessages.length) {
                    //TODO Setup messages UI
                    //TODO Remove <p> in api response
                    /*prepareBookResponse.vendorMessages.forEach(msg =>
                        this.$toast.warning(msg, {
                            icon: 'mdi-information',
                            closeIcon: 'mdi-close',
                            showClose: true,
                            timeout: 0,
                        })
                    )*/
                }
                if (prepareBookResponse.dueToConfirmDate) {
                    this.dueToConfirmDate = prepareBookResponse.dueToConfirmDate
                }
            }
            return true
        }

        prepareBookErrorProcessing(e) {
            //TODO Check other API errors
            if (e.status === 404) {
                //TODO Show offers expired
            } else {
                //TODO Is need to show all API messages?
                let hasValidationMessages = false
                if (e.errors) {
                    e.errors.forEach(e => {
                        if (e.errorType === 'validation') {
                            hasValidationMessages = true
                            let errorMsg = e.message
                            if (e.token === 'api.please.specify.serviceRPH.and.quantity') {
                                errorMsg = this.$t('extraServices.errors.empty_qty')
                            } else if (e.token === 'api.comment.is.too.long') {
                                errorMsg = this.$t('api_error_token.max_length_of_comment_is_1024')
                            }
                            this.$toast.error(errorMsg, {queueable: true})
                        }
                    })
                }
                if (!hasValidationMessages) {
                    this.$toast.error(this.$t('error_message.prepare_book_unknown_error'))
                }
            }
            return false
        }

        async makeOnlinePayment() {
            try {
                const paymentInitiateRs = await persistentStore.paymentInitiate(this.getPaymentInitiateRq())
                if (paymentInitiateRs.simpleRedirect) {
                    if (paymentInitiateRs.parameters.length) {
                        const query = new URLSearchParams(
                            paymentInitiateRs.parameters.map(({name, value}) => [name, value])
                        )
                        window.location = paymentInitiateRs.url + '?' + query
                    } else {
                        window.location = paymentInitiateRs.url
                    }
                } else {
                    const paymentMethod = persistentStore.paymentMethods.find(
                        paymentMethod => paymentMethod.id === this.paymentMethodId
                    )
                    if (paymentMethod.pspCode === 'webpay' && this.$conf.public.webpayContractDomain) {
                        const {url, parameters, paymentNumber, paymentTransactionId} = paymentInitiateRs
                        await this.$refs.paymentRedirectForm.submit({
                            url: `${this.$conf.public.webpayContractDomain}/payment-redirect`,
                            parameters,
                            paymentNumber,
                            paymentTransactionId,
                            originUrl: url,
                        })
                    } else if (paymentMethod.pspCode === 'stripe') {
                        const {APIPublicKey, sessionId} = paymentInitiateRs.parameters.reduce(
                            (parameters, {name, value}) => {
                                parameters[name] = value
                                return parameters
                            },
                            {}
                        )
                        const {loadStripe} = await import('@stripe/stripe-js')
                        const stripe = await loadStripe(APIPublicKey)
                        await stripe.redirectToCheckout({sessionId})
                    } else if (paymentMethod.pspCode === 'adyen') {
                        const findParameter = (name, array) => {
                            return array.find(e => e.name === name)?.value
                        }
                        const AdyenCheckout = (await import('@adyen/adyen-web')).default
                        const checkout = await AdyenCheckout({
                            session: {
                                id: findParameter('SESSION_ID', persistentStore.paymentInitiateResponse.parameters),
                                sessionData: findParameter(
                                    'SESSION_DATA',
                                    persistentStore.paymentInitiateResponse.parameters
                                ),
                            },
                            clientKey: findParameter(
                                'CLIENT_API_KEY',
                                persistentStore.paymentInitiateResponse.parameters
                            ),
                            environment: findParameter(
                                'ENVIRONMENT',
                                persistentStore.paymentInitiateResponse.parameters
                            ),
                            onPaymentCompleted: res => {
                                if (res.resultCode.toLowerCase() === 'authorised') {
                                    const params = {
                                        paymentNumber: paymentInitiateRs.paymentNumber,
                                        ...res,
                                    }
                                    window.location = `${this.getPaymentSuccessUrl()}&${new URLSearchParams(
                                        params
                                    ).toString()}`
                                } else {
                                    window.location = `${this.getPaymentInitiateRq().failureUrl}`
                                }
                            },
                            onError: () => {},
                        })

                        checkout.create('dropin').mount('#dropin-container')
                    } else if (paymentMethod.pspCode === 'nmi') {
                        const params = paymentInitiateRs.parameters.reduce((parameters, {name, value}) => {
                            parameters[name] = value
                            return parameters
                        }, {})

                        let my_awesome_script = document.createElement('script')

                        my_awesome_script.setAttribute(
                            'src',
                            'https://cibcfcib.transactiongateway.com/token/Collect.js'
                        )
                        my_awesome_script.setAttribute('data-tokenization-key', params['public-key'])
                        my_awesome_script.setAttribute('data-variant', 'inline')
                        my_awesome_script.onload = async () => {
                            const params = {
                                paymentNumber: paymentInitiateRs.paymentNumber,
                            }
                            this.nmiPaymentSuccessUrl = `${this.getPaymentSuccessUrl()}&${new URLSearchParams(
                                params
                            ).toString()}`
                        }
                        document.head.appendChild(my_awesome_script)
                    } else if (paymentMethod.pspCode === 'flywire') {
                        return new Promise(resolve => {
                            const params = paymentInitiateRs.parameters.reduce((parameters, {name, value}) => {
                                parameters[name] = value
                                return parameters
                            }, {})
                            const {callbackId, callbackUrl, callbackVersion, paymentFormUrl, recipientCode} = params
                            const paymentAuthorization = {
                                type: params['paymentAuthorization.type'],
                            }
                            const recipientFields = {
                                booking_reference: params['recipientFields.booking_reference'],
                            }

                            const config = {
                                env: params.env,
                                amount: paymentMethod.totalAmount?.value?.toFixed(2),
                                recipientCode,
                                recipientFields,
                                callbackId,
                                callbackUrl,
                                callbackVersion,
                                paymentFormUrl,
                                ...(paymentAuthorization?.type && {paymentAuthorization}),
                                requestPayerInfo: true,
                                onCompleteCallback: args => {
                                    const params = {
                                        paymentNumber: paymentInitiateRs.paymentNumber,
                                        reference: args.reference,
                                        status: args.status,
                                    }

                                    window.location = `${this.getPaymentSuccessUrl()}&${new URLSearchParams(
                                        params
                                    ).toString()}`
                                    resolve(true)
                                },
                                onCancel: () => {
                                    resolve(false)
                                },
                                onInvalidInput: errors => {},
                            }

                            let modal = window.FlywirePayment?.initiate(config)
                            modal?.render()
                        })
                    } else {
                        await this.$refs.paymentRedirectForm.submit(paymentInitiateRs)
                    }
                }

                return true
            } catch (e) {
                console.error(e)
                EventBus.$emit(SHOW_NOTIFICATIONS, {
                    notifications: [this.$t('error_message.payment_initiate_error')],
                    color: 'error',
                })
                return false
            }
        }

        onNMIPaymentFinish(response) {
            const params = {
                payment_token: response.token,
                first_name: response.firstName,
                last_name: response.lastName,
                address: response.address,
                email: response.email,
            }

            window.location = `${this.nmiPaymentSuccessUrl}&${new URLSearchParams(params).toString()}`
        }

        getPaymentInitiateRq() {
            return {
                ...(this.bookingKey && {bookingKey: this.bookingKey}),
                ...(this.basketKey && {basketKey: this.basketKey}),
                paymentMethodId: this.paymentMethodId,
                successUrl: this.getPaymentSuccessUrl(),
                failureUrl: this.getPaymentCancelUrl('failure'),
                cancelUrl: this.getPaymentCancelUrl('cancel'),
                ...(this.numberOfPayments && {splitPaymentQuantity: this.numberOfPayments}),
            }
        }

        getPaymentSuccessUrl() {
            return (
                window.location.origin +
                this.$router.resolve({
                    name: 'paymentComplete',
                    query: {
                        paymentMethodId: this.paymentMethodId,
                        ...(this.bookingKey && {bookingKey: this.bookingKey}),
                        ...(this.basketKey && {basketKey: this.basketKey}),
                        product: this.productName,
                        ...(this.corporatePolicyViolationCodeId && {
                            corporatePolicyViolationCodeId: this.corporatePolicyViolationCodeId,
                        }),
                        ...(this.dueToConfirmDateActive && {dueToConfirmDate: this.dueToConfirmDate}),
                        ...(this.agentRefNumber && {agentRefNumber: this.agentRefNumber}),
                        ...this.extendedPaymentSuccessUrlParams,
                    },
                }).href
            )
        }

        get extendedPaymentSuccessUrlParams() {
            return {}
        }

        get isInitFlywire() {
            return !!persistentStore.paymentMethods?.find(paymentMethod => paymentMethod.pspCode === 'flywire')
        }

        @Watch('isInitFlywire')
        onIsInitFlywireChange() {
            if (this.isInitFlywire) {
                useHead({
                    script: [
                        {
                            src: 'https://checkout.flywire.com/flywire-payment.js',
                            async: true,
                            defer: true,
                        },
                    ],
                })
            }
        }
    }

    export default BookingMixin
</script>
